import React from "react";
import PropTypes from "prop-types";
import { usePadding } from "@/components/utils/Padding";
import Marquee from "react-fast-marquee";
import "./styles.scss";

/* #META
 {
  "NAME": "Chips",
  "CLASSNAME": "chips-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const Chips = ({ data }) => {
  const chipsModule = data?.chips_module;
  if (!chipsModule) return null;

  const { chips_grid, padding_component } = chipsModule;

  const paddingStyle = usePadding(padding_component);

  return (
    <section className="chips-component" style={paddingStyle}>
      <div className="marquee-container">
        <Marquee gradient={false} speed={50} loop={0} autoFill={true}>
          {chips_grid?.map((chip, index) => (
            <span key={index} className="chip-single">
              {chip?.chips}
            </span>
          ))}
        </Marquee>
        <Marquee gradient={false} speed={50} loop={0} autoFill={true} direction="right">
          {chips_grid?.map((chip, index) => (
            <span key={index} className="chip-single">
              {chip?.chips}
            </span>
          ))}
        </Marquee>
        <Marquee gradient={false} speed={50} loop={0} autoFill={true}>
          {chips_grid?.map((chip, index) => (
            <span key={index} className="chip-single">
              {chip?.chips}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

Chips.propTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    chips_module: PropTypes.shape({
      chips_grid: PropTypes.arrayOf(
        PropTypes.shape({
          chips: PropTypes.string,
        })
      ),
    }),
  }),
};

export default Chips;
